module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_8017.dc52e281.png";